import { render } from "./ActiveFilters.vue?vue&type=template&id=b1981d62&scoped=true"
import script from "./ActiveFilters.vue?vue&type=script&lang=js"
export * from "./ActiveFilters.vue?vue&type=script&lang=js"

import "./ActiveFilters.vue?vue&type=style&index=0&id=b1981d62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1981d62"]])

export default __exports__